import Typography from "@mui/material/Typography";
import { FC, ReactNode } from "react";
import { COLOR_GREY_12, COLOR_GREY_10 } from "shared/theme/colors";
import {
  StyledSwitcher,
  StyledSwitcherOption,
  StyledSwitcherOptionIcon,
} from "./styled";

export type SwitcherOption = {
  id: string;
  label: string;
  icon?: ReactNode;
};

export type SwitcherProps = {
  options: SwitcherOption[];
  activeOptionId: string;
  onChange: (optionId: string) => void;
  className?: string;
  labelVisible?: boolean;
};

const Switcher: FC<SwitcherProps> = ({
  options,
  activeOptionId,
  onChange,
  className,
  labelVisible = true,
}) => {
  return (
    <StyledSwitcher className={className}>
      {options.map((option) => {
        const isActive = option.id === activeOptionId;

        return (
          <StyledSwitcherOption
            key={option.id}
            isActive={isActive}
            onClick={() => onChange(option.id)}
          >
            {option.icon && (
              <StyledSwitcherOptionIcon>{option.icon}</StyledSwitcherOptionIcon>
            )}
            {labelVisible && (
              <Typography
                variant="bodyMRegular"
                color={isActive ? COLOR_GREY_12 : COLOR_GREY_10}
              >
                {option.label}
              </Typography>
            )}
          </StyledSwitcherOption>
        );
      })}
    </StyledSwitcher>
  );
};

export default Switcher;
